import { render, staticRenderFns } from "./ConfirmTab.vue?vue&type=template&id=fb0b7338&scoped=true"
import script from "./ConfirmTab.vue?vue&type=script&lang=js"
export * from "./ConfirmTab.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTab.vue?vue&type=style&index=0&id=fb0b7338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0b7338",
  null
  
)

export default component.exports